import { render, staticRenderFns } from "./sideRuler.vue?vue&type=template&id=4edbc948&"
import script from "./sideRuler.vue?vue&type=script&lang=js&"
export * from "./sideRuler.vue?vue&type=script&lang=js&"
import style0 from "./sideRuler.vue?vue&type=style&index=0&id=4edbc948&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports